var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isloading),expression:"isloading"}]}),_vm._v(" "),((_vm.status === 1))?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }